<template>
  <div>
    <div class="search-body">
      <!-- <lawSearchInfo :list="conditionList" remove @removeFilter="removeFilter" /> -->
      <!-- <historySearch class="case-search-history-search" type="law"/> -->
      <!-- <div class="search-condition" v-if="conditionList.length">
        <span class="condition-item-first">检索条件</span>
        <el-tag
          type="danger"
          effect="plain"
          v-for="(item, index) in conditionList"
          :key="'conditionList' + index"
          closable
          @close="removeFilter(item, index)"
          :disable-transitions="true"
          >{{ item.name }}：{{ item.value }}</el-tag
        >
      </div> -->
      <!-- <keep-alive> -->
      <!-- <law-page :param="this.$route.query.param" :searchType="this.$route.query.searchType" :clId="this.$route.query.clId" v-on:changeStatus="changeStatus"></law-page> -->
      <law-page ref="lawPage"></law-page>
      <!-- </keep-alive> -->
    </div>
  </div>
</template>

<script>
import lawPage from '@/views/law/law';

export default {
  data() {
    return {
      list: {},
      version: window.version,
    };
  },
  components: { lawPage, },
  watch: {
    $route: function(val) {
      if (val) {
        this.changeStatus();
      }
    }
  },
  methods: {
    refreshData() {
      this.$refs.lawPage.fetchData();
    },
    changeStatus() {
      this.$emit('changeStatus', false);
    },
    removeFilter(condition, index) {
      this.$refs.lawPage.removeFilter(condition, index);
      this.$emit('removeFilter');
    }
  }
};
</script>
<style scoped lang="less">
.overflow-ellipsis {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
  display: block;
  color: @wordColor2;
  padding-right: 20px;
}

.lawResult-right-item {
  margin-top: 20px;
  background: #fff;
  padding: 16px 0px;
  box-shadow: 0px 4px 5px 0px rgba(118, 118, 118, 0.08);
  overflow-y: auto;
  overflow-x: hidden;
}

.lawResult-right-item-title {
  color: @wordColor1;
  font-weight: bold;
  height: 40px;
  line-height: 40px;
  padding-left: 10px;
}

.last-item-color {
  color: @wordColor2;
}

.result {
  position: relative;
}

.tip-head {
  width: 100%;
  height: 35px;
  background: @headerColor;
}

.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 3000;
  position: absolute;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
}

.contextmenu li {
  margin: 0;
  padding: 7px 16px;
  cursor: pointer;
}

.contextmenu li:hover {
  background: #eee;
}

.search-condition {
  font-size: 14px;
  color: #666;
  padding: 15px 280px 0 0;
  width: 100%;
  clear: both;
  box-sizing: border-box;

  &:after {
    content: '';
    display: block;
    clear: both;
    width: 100%;
    height: 1px;
  }

  span {
    max-width: 100%;
    height: fit-content;
    white-space: normal;
    margin: 0 16px 10px 0;
    float: left;
    font-size: 14px;

    &.condition-item-first {
      padding: 10px 14px 10px 0;
      margin: 0;
      border: 1px solid transparent;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/law/home.vue